<template>
  <div v-if="visibleHints.length" class="discovery-stats-hints">
    <div
      v-for="(section, i) in visibleHints"
      :key="i"
      class="discovery-stats-hints__item"
    >
      <p class="discovery-stats-hints__title">
        {{ section.title }}
      </p>

      <div class="discovery-stats-hints__box">
        <DiscoveryStatsHintsItem
          v-for="(hint, j) in section.items"
          :key="j"
          :title="hint.title"
          :description="hint.description"
          :link="hint.link"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DiscoveryStatsHintsItem from './DiscoveryStatsHintsItem';

export default {
  name: 'DiscoveryStatsHints',

  components: {
    DiscoveryStatsHintsItem,
  },

  props: {
    packageName: {
      type: String,
      required: true,
    },
    showM2v: Boolean,
    showV2d: Boolean,
    showD2i: Boolean,
  },

  computed: {
    hints() {
      return [
        {
          isVisible: this.showM2v,
          title: this.$t(
            'ADVERTISEMENT.DISCOVERY_ADS.HINTS.IMPACT_RATE_TO_VISIT',
          ),
          items: [
            {
              title: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_LOGO.TITLE',
              ),
              description: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_LOGO.DESCRIPTION',
              ),
              link: this.generateLink('app-media'),
            },
            {
              title: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_NAME.TITLE',
              ),
              description: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_NAME.DESCRIPTION',
              ),
              link: this.generateLink('app-info'),
            },
            {
              title: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.DESCRIPTION_IN_NAME.TITLE',
              ),
              description: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.DESCRIPTION_IN_NAME.DESCRIPTION',
              ),
              link: this.generateLink('app-info'),
            },
          ],
        },

        {
          isVisible: this.showD2i,
          title: this.$t(
            'ADVERTISEMENT.DISCOVERY_ADS.HINTS.DOWNLOAD_RATE_TO_INSTALL',
          ),
          items: [
            {
              title: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.FIRST_IMAGE.TITLE',
              ),
              description: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.FIRST_IMAGE.DESCRIPTION',
              ),
              link: this.generateLink('app-media'),
            },
            {
              description: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.DECREASE_SIZE',
              ),
            },
          ],
        },

        {
          isVisible: this.showV2d,
          title: this.$t(
            'ADVERTISEMENT.DISCOVERY_ADS.HINTS.VISIT_RATE_TO_DOWNLOAD',
          ),
          items: [
            {
              title: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_DESCRIPTION.TITLE',
              ),
              description: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_DESCRIPTION.DESCRIPTION',
              ),
              link: this.generateLink('app-info'),
            },
            {
              title: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_IMAGES.TITLE',
              ),
              description: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.CHANGE_IMAGES.DESCRIPTION',
              ),
              link: this.generateLink('app-media'),
            },
            {
              title: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.ASNWER_COMMENTS.TITLE',
              ),
              description: this.$t(
                'ADVERTISEMENT.DISCOVERY_ADS.HINTS.ASNWER_COMMENTS.DESCRIPTION',
              ),
              link: this.generateLink('app-reviews'),
            },
          ],
        },
      ];
    },
    visibleHints() {
      return this.hints.filter(hint => hint.isVisible);
    },
  },

  methods: {
    generateLink(routeName) {
      return this.$router.resolve({
        name: routeName,
        params: {
          packageName: this.packageName,
        },
      }).href;
    },
  },
};
</script>

<style lang="scss">
.discovery-stats-hints {
  width: 100%;
  background-color: #fff;

  border: 1px solid $lb-light-gray;
  border-radius: $lb-border-radius * 5;
  padding: $global-padding * 2;

  &__title {
    font-size: rem-calc(12px);
    font-weight: 700;
    margin-bottom: $global-margin;
  }

  &__box {
    background: #fafafa;
    border-radius: 4px;
    padding: 0 $global-padding * 0.5;
  }

  &__item:not(:last-child) {
    margin-bottom: $global-margin * 1;
  }
}
</style>
